<template>
  <!-- 在线合同管理-->
  <el-container class="contract-management-online pagination-list">
    <el-main>
      <div class="content">
        <div class="contract-management-search">
          <el-form @submit.native.prevent>
            <el-form-item>
              <el-input v-model="keyword" clearable placeholder="请输入发起人、签署人、合同名称" @keydown.native.enter="search"></el-input>
            </el-form-item>
            <el-button @click="search" size="mini">查询</el-button>
          </el-form>
        </div>
        <div class="contract-management-table">
          <el-table
            class="table-list"
            v-loading="loading"
            height="100%"
            border
            :data="data"
            highlight-current-row
            :cell-style="cellStyle">
            <el-table-column
              show-overflow-tooltip
              v-for="column in columns"
              :label="column.label"
              :key="column.prop"
              :prop="column.prop"
              align="center"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="操作"
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="contractSignature(scope.row)">合同签章</el-button>
                <el-button type="text" @click="contractPreview(scope.row.contractId)">合同预览</el-button>
                <el-button type="text" @click="downloadContract(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-footer">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="total, prev, pager, next, sizes"
            :total="pagination.total"
            :page-size="pagination.pageSize"
            background
          >
          </el-pagination>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>

export default {
  name: 'contract-management-online',
  data () {
    return {
      keyword: '',
      columns: [
        {
          prop: 'sponsor',
          label: '发起人'
        }, {
          prop: 'signatory',
          label: '签署人'
        }, {
          prop: 'subject',
          label: '合同名称'
        }, {
          prop: 'publishTime',
          label: '发起时间'
        }, {
          prop: 'signTime',
          label: '签署时间'
        }, {
          prop: 'signStatus',
          label: '签署状态'
        }
      ],
      data: [],
      loading: false,
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.search()
  },
  methods: {
    // 单元格样式
    cellStyle ({row, column}) {
      if (row.signStatus === '进行中' && column.label === '签署状态') {
        return 'color: #409EFF'
      }
    },
    search () {
      this.loading = true
      this.$axios.get('/system-api/contract/manageList', {
        params: {
          index: this.pagination.currentPage,
          size: this.pagination.pageSize,
          filters: {
            keyword: this.keyword
          }
        }
      }).then(res => {
        this.data = res.data.items
        this.pagination.total = res.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 合同预览
    contractPreview (cid) {
      let a = document.createElement('a')
      let e = document.createEvent('mouseevent')
      a.style.display = 'none'
      a.target = '_blank'
      e.initEvent('click', false, false)
      document.body.appendChild(a)
      this.$axios.post(`/system-api/contract/view/${cid}`, {
        disableInterceptors: true
      }).then(res => {
        // 兼容safari (window.open 会因默认安全问题被阻止)
        a.href = res.data.pageUrl
        a.dispatchEvent(e)
        document.body.removeChild(a)
      }).catch(() => {
        document.body.removeChild(a)
      })
    },
    // 合同签章
    contractSignature (contract) {
      let cid = contract.contractId
      if (contract.signStatus === '已完成') {
        return this.$message.warning('合同已完成，无法签章')
      }
      let a = document.createElement('a')
      let e = document.createEvent('mouseevent')
      a.style.display = 'none'
      a.target = '_blank'
      e.initEvent('click', false, false)
      document.body.appendChild(a)
      this.$axios.post(`/system-api/contract/generateSignUrl/${cid}`, {
        disableInterceptors: true
      }).then(res => {
        // 兼容safari (window.open 会因默认安全问题被阻止)
        a.href = res.data.pageUrl
        a.dispatchEvent(e)
        document.body.removeChild(a)
      }).catch(() => {
        document.body.removeChild(a)
      })
    },
    // 合同下载
    downloadContract (contract) {
      let cid = contract.contractId
      // let cName = contract.subject
      // let cPtime = contract.publishTime
      if (contract.signStatus !== '已完成') {
        return this.$message.warning('请完成合同签署后再下载查看')
      }
      this.$axios({
        method: 'GET',
        url: `/system-api/contract/download/${cid}`
      }).then(res => {
        if (res.data && res.data[0] && res.data[0].status === 'success') {
          let ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
          window.open(`${ossDownloadUrl}${res.data[0].result.dir}`)
        }
        // let blob = new Blob([res.data], {type: 'application/zip'})
        // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        //   //  ie
        //   window.navigator.msSaveOrOpenBlob(blob, cName + cPtime + '.zip')
        // } else {
        //   let url = window.URL.createObjectURL(blob)
        //   let vDom = document.createElement('a')
        //   vDom.style.display = 'none'
        //   vDom.href = url
        //   vDom.setAttribute('download', cName + cPtime + '.zip')
        //   document.body.appendChild(vDom)
        //   vDom.click()
        //   document.body.removeChild(vDom)
        //   window.URL.revokeObjectURL(url)
        // }
      })
    },
    // 分页
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.search()
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.search()
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';

  .el-container.contract-management-online {
    font-size: 12px;
    .contract-management-search{
      .el-form {
        height: 37px;
        .el-form-item{
          display: inline-block;
          .el-input{
            width: 268px;
          }
        }
      }
      .el-button{
        margin-left: 20px;
        border: 1px solid #55acf1;
        color: #55acf1;
        padding: 5px;
        vertical-align: middle;
      }
    }
    .contract-management-table{
      height: calc(100% - 45px);
      padding: 0 10px;
    }
    .online-contract-iframe{
      position: fixed;
      z-index: 2000;
      min-height: 0;
      padding-top: 0;
      margin-top: 0;
      top: 80px;
      bottom: 0;
      right: -860px;
      width: 860px;
      overflow-x: hidden;
      overflow-y: auto;
      box-shadow: -1px 2px 4px 0 rgba(0,0,0,.22);
      transition: all .5s ease-in-out;
      .frame-menu-head{
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        background-color: #f7f8f8;
        border-bottom: 1px solid #f2f3f4;
        span+span{
          float: right;
          cursor: pointer;
          &:hover{
            color: #62a8f2;
          }
        }
      }
      .contract-frame{
        width: 100%;
        height: calc(100% - 40px);
        border: none;
      }
    }
    .online-contract-iframe.contract-aside-dialog{
      right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/system/contract-management-online.vue